export default __webpack_public_path__ + "a720d3e3ddf40fa9ee0bd3eb7ee568ed.svg";